// src/components/pages/UserSwitcher.jsx
// Selector con búsqueda para que el admin "vea como" un colaborador (o vuelva a la vista equipo).
import React, { useState, useRef, useEffect } from 'react';
import { FiChevronsDown, FiSearch, FiUsers } from 'react-icons/fi';

const Avatar = ({ u }) => (
    u?.photoURL
        ? <img src={u.photoURL} className="w-6 h-6 rounded-full object-cover shrink-0" alt="" />
        : <div className="w-6 h-6 rounded-md bg-gradient-to-br from-sky-600 to-blue-700 text-white text-[10px] font-extrabold flex items-center justify-center shrink-0">
            {(u?.displayName || u?.email || '?').charAt(0).toUpperCase()}
        </div>
);

const UserSwitcher = ({ users = [], value, onChange }) => {
    const [open, setOpen] = useState(false);
    const [q, setQ] = useState('');
    const ref = useRef(null);

    useEffect(() => {
        const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        if (open) document.addEventListener('mousedown', h);
        return () => document.removeEventListener('mousedown', h);
    }, [open]);

    const selected = users.find(u => u.id === value);
    const list = users
        .filter(u => u.status === 'active')
        .filter(u => !q || (u.displayName || u.email || '').toLowerCase().includes(q.toLowerCase()))
        .sort((a, b) => (a.displayName || a.email || '').localeCompare(b.displayName || b.email || ''));

    return (
        <div className="relative" ref={ref}>
            <button onClick={() => setOpen(o => !o)}
                className="w-full px-3 py-2.5 rounded-xl bg-gray-50 border border-gray-200 flex items-center gap-2 hover:bg-gray-100 transition">
                {selected ? <Avatar u={selected} /> : <FiUsers className="w-5 h-5 text-sky-600 shrink-0" />}
                <span className="text-[12.5px] text-gray-900 font-semibold flex-1 truncate text-left">
                    {selected ? (selected.displayName || selected.email?.split('@')[0]) : 'Vista equipo'}
                </span>
                <FiChevronsDown size={12} className="text-gray-400 shrink-0" />
            </button>
            {open && (
                <div className="absolute left-0 right-0 top-full mt-1 bg-white rounded-xl shadow-xl border border-gray-200 z-50 overflow-hidden">
                    <div className="p-2 border-b border-gray-100">
                        <div className="relative">
                            <FiSearch className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-400" size={12} />
                            <input autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="Buscar colaborador..."
                                className="w-full pl-7 pr-2 py-1.5 border border-gray-200 rounded-lg text-[12px] outline-none focus:ring-1 focus:ring-sky-400" />
                        </div>
                    </div>
                    <div className="max-h-72 overflow-y-auto py-1">
                        <button onClick={() => { onChange(null); setOpen(false); setQ(''); }}
                            className={`w-full px-3 py-2 flex items-center gap-2 text-left hover:bg-gray-50 ${!value ? 'bg-sky-50' : ''}`}>
                            <FiUsers className="w-5 h-5 text-sky-600 shrink-0" />
                            <span className="text-[12.5px] font-semibold text-gray-800">Vista equipo (admin)</span>
                        </button>
                        {list.map(u => (
                            <button key={u.id} onClick={() => { onChange(u.id); setOpen(false); setQ(''); }}
                                className={`w-full px-3 py-2 flex items-center gap-2 text-left hover:bg-gray-50 ${value === u.id ? 'bg-sky-50' : ''}`}>
                                <Avatar u={u} />
                                <span className="text-[12.5px] text-gray-800 truncate">{u.displayName || u.email?.split('@')[0]}</span>
                            </button>
                        ))}
                        {list.length === 0 && <p className="px-3 py-3 text-[11px] text-gray-400 text-center">Sin resultados</p>}
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserSwitcher;
